
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { InitialisationService } from 'qmuzik-angular-service';
import { EISTaskSecurityService } from '../../../service/generated/eistasksecurity.service';
import { EISTaskSecurity } from 'qmuzik-angular-model';
import { EISTaskSecurityModelStateValidation } from '../../../modelstate-validation/generated/eistasksecurity-modelstate.validate';
import { EISTaskSecurityViewStateValidation } from '../../../viewstate-validation/generated/eistasksecurity-viewstate.validate';
import { ModelStateValidation } from 'qmuzik-angular-model-core';
import { ModelStateValidationBase } from 'qmuzik-angular-base';
import { ViewStateValidation } from 'qmuzik-angular-model-core';
import { ViewStateValidationBase } from 'qmuzik-angular-base';
import { ComponentBase } from 'qmuzik-angular-base';
import { LoginService } from 'qmuzik-angular-service';
import { UtilityService } from 'qmuzik-angular-service';
import { NotificationService } from 'qmuzik-angular-service';
import { ValidationError } from 'qmuzik-angular-model-core';
import { Router } from '@angular/router';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

/**
 * Base class for all entity components of a specific type
 */
@Component({
	template: ''
  })
export class EISTaskSecurityComponent extends ComponentBase implements OnInit {
	public errors: ValidationError[] = [];
	public asyncErrors: ValidationError[] = [];    
	public warnings: ValidationError[] = [];
	public asyncWarnings: ValidationError[] = [];    
	public informations: ValidationError[] = [];  
	public asyncInformations: ValidationError[] = [];   

	constructor(
		initialisationService: InitialisationService,
		//all data related functionality here
		//create, read, update delete etc. etc.
		//override: inherit from this service to add your own data access functionality should you require it
		dataService: EISTaskSecurityService,
		//all business rules for the model handled here
		modelStateValidation: EISTaskSecurityModelStateValidation,
		//all changes that affect the view handled here
		viewStateValidation: EISTaskSecurityViewStateValidation,
		//we need this for the data contexts
		loginService: LoginService,
		utilityService: UtilityService,
		notificationService: NotificationService,
		router: Router) 
	{     
		super(initialisationService, loginService, utilityService, notificationService, router);

		//all these may be overridden in a child
		//set the model state for the model state rule validator
		//note: see how the modelstate validator should NEVER EVER need to know about the view state
		this.modelStateType = EISTaskSecurity;

		this.dataService = dataService;
		this.viewStateValidation = viewStateValidation;
		this.initialisationService = initialisationService;
		this.modelStateValidation = modelStateValidation;
	}

	ngOnInit() {
		//do what we can on base first
		super.ngOnInit();
	}

}

